





import { Component, Vue, Watch } from "vue-property-decorator";
import EmployeeAttendDetails from "@/components/EmployeeAttendDetails.vue";
import store from "@/store";
@Component({
  components: { EmployeeAttendDetails }
})
export default class ManagerEmployeeDetailsPage extends Vue {
  constructor() {
    super();
  }

  created() {
    this.onSetScreenTitle();
  }
  
  @Watch("selectedYear")
  @Watch("selectedMonth")
  onSetScreenTitle() {
    this.appEnv.screenTitle =
      this.$t("attend") +
      " " +
      this.$t("months." + this.selectedMonth.toString()) +
      " " +
      this.selectedYear;
  }

  get selectedYear() {
    return store.getters.selectedYear;
  }

  get selectedMonth() {
    return store.getters.selectedMonth;
  }

  get appEnv() {
    return store.getters.appEnv;
  }
}
